<div class="datetime-picker">
  <ngb-datepicker [(ngModel)]="date" [minDate]="minDate"></ngb-datepicker>
  <ngb-timepicker [(ngModel)]="time" [meridian]="true"></ngb-timepicker>
</div>
<div class="btns">
  <button class="btn ss-btn-primary-inverse btn-custom-step btn-custom-step-gray" (click)="close()">Cancel</button>
  <button class="btn btn-primary btn-custom-step" (click)="ok()">OK</button>
</div>
